import "./Equipment.module.css";
import CorporateHeader from "@/reusable_sections/Header";
import AdvancedMedicalFacilities from "./sections/AdvancedMedicalFacilities";
import FleetCapabilities from "./sections/FleetCapabilities";
import ReadyToStreamline from "./sections/ReadyToStreamline";
import GlobalFooter from "@/reusable_sections/Footer";
export default function EquipmentPage() {
  return <div>
      <CorporateHeader />
      <AdvancedMedicalFacilities />
      <FleetCapabilities />
      <ReadyToStreamline />
      <GlobalFooter />
    </div>;
}